import { Error, Paging } from "api/baseApiResponseModel/BaseApiResponseModel";
import { BaseSupportFeatureRequestModel } from "api/baseSupportFeatureModel/BaseSupportFeatureRequestModel";
import { BaseViewModel } from "components/base/BaseViewModel";
import { BehaviorSubject, Subject } from "rxjs";
import { injectable } from "tsyringe";
import { TypeOfSupportEnum } from "utils/enums/TypeOfSupportEnum";
import { ServiceRepo } from "utils/serviceRepo/ServiceRepo";

class SupportFeatureInput implements Disposable {
  public fetchSupportFeature = new Subject<BaseSupportFeatureRequestModel>();
  public loading = new BehaviorSubject<boolean>(false);

  [Symbol.dispose](): void {
    this.fetchSupportFeature.complete();
    this.loading.complete();
  }
}

class SupportFeatureOutput implements Disposable {
  public savedLookupData = new BehaviorSubject<unknown>(undefined);
  public savedPaging = new BehaviorSubject<Paging>({});
  public onError = new BehaviorSubject<Error>({});
  [Symbol.dispose](): void {
    this.savedLookupData.complete();
    this.savedPaging.complete();
    this.onError.complete();
  }
}

@injectable()
export class SupportFeatureViewModel extends BaseViewModel<
  SupportFeatureInput,
  SupportFeatureOutput
> {
  constructor() {
    super(new SupportFeatureInput(), new SupportFeatureOutput());
  }
  private repo = ServiceRepo.getSupportFeatureRepo();

  protected override transform(): void {
    this.input.fetchSupportFeature
      .subscribe(async (params) => {
        try {
          this.input.loading.next(true);
          let typeofSupport = params?.typeOfSupport;
          delete params?.typeOfSupport;
          let res = undefined;
          switch (typeofSupport) {
            case TypeOfSupportEnum.viewPlan:
              res = await this.repo.viewPlan(params);
              if (res?.data) {
                this.output.savedLookupData.next(res?.data);
                break;
              }
              break;
            case TypeOfSupportEnum.viewSim:
              res = await this.repo.viewSim(params);
              if (res?.data) {
                this.output.savedLookupData.next(res?.data);
                break;
              }
              break;
          }
        } catch (error) {
          console.error(error);
          this.output.onError.next(error);
        } finally {
          this.input.loading.next(false);
        }
      })
      .add(this.subscriptions);
  }
}
